import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button } from 'react-bootstrap'; // 引入 React-Bootstrap 组件
import api from '../api'; // 你封装的 axios 实例

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/api/admin/login', {
        username,
        password,
      });
      alert(res.data.message || '管理员登录成功');

      // 后端返回 token => 存储到 localStorage
      const { token } = res.data;
      localStorage.setItem('token', token);

      // 设置全局 axios token header
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      // 跳转到后台首页（示例路径）
      navigate('/admin/dashboard');

    } catch (err) {
      console.error('管理员登录失败:', err);
      alert(err.response?.data?.message || '管理员登录失败');
    }
  };

  return (
    <div style={styles.pageWrapper}>
      <Container style={styles.container}>
        <Card style={styles.card}>
          <Card.Body>
            <h3 className="text-center mb-4" style={{ fontWeight: 'bold' }}>
              管理员登录
            </h3>
            <Form onSubmit={handleAdminLogin}>
              <Form.Group className="mb-3" controlId="adminUsername">
                <Form.Label>用户名</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="请输入管理员用户名"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  style={styles.input}
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="adminPassword">
                <Form.Label>密码</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="请输入管理员密码"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={styles.input}
                />
              </Form.Group>

              <Button variant="primary" type="submit" style={styles.button} className="w-100">
                登录
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

// 样式定义示例
const styles = {
  pageWrapper: {
    // 全屏背景（示例：纯色，或渐变，也可放置图片）
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
    // 居中
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // 如果想在移动端效果更好，可加点内边距
    padding: '20px',
  },
  container: {
    maxWidth: '380px',
    width: '100%',
  },
  card: {
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    overflow: 'hidden',
  },
  input: {
    fontSize: '1rem',
    padding: '0.75rem',
  },
  button: {
    fontSize: '1.1rem',
    padding: '0.6rem',
  },
};

export default AdminLogin;